// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title[data-v-774a3e02]{\n    height: 30px;\n    line-height: 30px;\n    font-size:14px;\n    font-weight:bold;\n}\n[data-v-774a3e02] .el-form-item__label:after {\n    content: \"\"!important;\n}\n", ""]);
// Exports
module.exports = exports;
